"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } /** When your routing table is too long, you can split it into small modules **/
var DecorationManagement = {
  path: '/Decoration',
  component: _layout.default,
  redirect: '/Decoration/popupWindows',
  name: 'Decoration',
  alwaysShow: true,
  meta: {
    title: '装修中心',
    icon: 'Decoration'
  },
  children: [{
    path: 'popupWindows',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/Decoration/popupWindows/index.vue'));
      });
    },
    name: 'PopupConfiguration',
    meta: {
      title: '弹窗配置',
      icon: ''
    }
  }, {
    path: 'PageDecoration',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/Decoration/PageDecoration/index.vue'));
      });
    },
    name: 'PageDecoration',
    meta: {
      title: '页面装修',
      icon: ''
    }
  }, {
    path: 'Sharelist',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/Decoration/Sharelist/index.vue'));
      });
    },
    name: 'ShareList',
    meta: {
      title: '分享列表',
      icon: ''
    }
  }, {
    path: 'PageConfig',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/Decoration/PageConfig/index.vue'));
      });
    },
    name: 'PageConfig',
    meta: {
      title: '页面配置',
      icon: ''
    }
  }, {
    path: 'NewLanding',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/Decoration/NewLanding/index.vue'));
      });
    },
    name: 'NewLanding',
    meta: {
      title: '上新落地页',
      icon: ''
    }
  }]
};
var _default = exports.default = DecorationManagement;